//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from "swiper";
export default {
  name: "business",
  data() {
    return {
      idx: 4,
      tab_idx: 0,
      about_tab: [
        {
          text: "业务范围",
          status: 0,
        },
        {
          text: "业务领域",
          status: 1,
        },
      ],
      business_list2: [],
      business_list3: [],
      business_list1: [],
      banner: [],
      nav: [
        {
          text: "首页",
          status: "0",
        },
        {
          text: "关于中启",
          status: "1",
        },
        {
          text: "工程案例",
          status: "2",
        },
        {
          text: "新闻中心",
          status: "3",
        },
        {
          text: "业务中心",
          status: "4",
        },
        {
          text: "人力资源",
          status: "5",
        },
        {
          text: "联系我们",
          status: "6",
        },
      ],
    };
  },
  updated: function () {
    new Swiper(".swiper1", {
      spaceBetween: 30,
      centeredSlides: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  },
  mounted() {
    this.getlist();
  },
  methods: {
    //鼠标移入
    enter1(a) {
      const _this = this;
      _this.business_list2[a].status = 1;
    },
    enter2(a) {
      const _this = this;
      _this.business_list1[a].status = 1;
    },
    enter3(a) {
      const _this = this;
      _this.business_list3[a].status = 1;
    },
    //鼠标移出
    leave1(a) {
      const _this = this;
      _this.business_list2[a].status = 0;
    },
    leave2(a) {
      const _this = this;
      _this.business_list1[a].status = 0;
    },
    leave3(a) {
      const _this = this;
      _this.business_list3[a].status = 0;
    },
    //获取具体数据
    getlist() {
      const _this = this;
      _this.$get("/header/business/fetch").then((res) => {
        console.log(res);
        _this.banner = res.data.bannerList;
        for (let i = 0; i < res.data.list.length; i++) {
          if (i == 0) {
            _this.business_list2.push(res.data.list[i]);
          } else if (i > 0 && i < 5) {
            _this.business_list1.push(res.data.list[i]);
          } else {
            _this.business_list3.push(res.data.list[i]);
          }
        }
      });
    },
    collect_click() {
      alert("请按住Ctrl+D收藏网站");
    },
    //导航跳转
    rout(a) {
      if (a == 0) {
        this.$router.push({
          path: "/",
        });
      } else if (a == 1) {
        this.$router.push({
          path: "/about",
        });
      } else if (a == 2) {
        this.$router.push({
          path: "/project",
        });
      } else if (a == 3) {
        this.$router.push({
          path: "/new",
        });
      } else if (a == 4) {
        this.$router.push({
          path: "/business",
        });
      } else if (a == 5) {
        this.$router.push({
          path: "/recruit",
        });
      } else if (a == 6) {
        this.$router.push({
          path: "/contact",
        });
      }
    },
    //tab点击事件
    tab_click(a) {
      const _this = this;
      _this.tab_idx = a;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/business.vue